// @flow
import type { Package, Action } from '../types';
import {
  PACKAGE_DETAILS_REQUEST,
  PACKAGE_DETAILS_REQUESTED_SUCCESS,
  PACKAGE_DETAILS_REQUESTED_ERROR
} from './constants';

export const requestPackageDetails = (slug: string): Action => ({
  type: PACKAGE_DETAILS_REQUEST,
  slug
});

export const successRequestPackageDetails = (data: Package, included: any): Action => ({
  type: PACKAGE_DETAILS_REQUESTED_SUCCESS,
  data,
  included
});

export const errorRequestPackageDetails = (error: Error): Action => ({
  type: PACKAGE_DETAILS_REQUESTED_ERROR,
  error
});
